class RecommendedCards extends React.Component {

  render() {

    return (

      <div className={"recommended_card card popular_post vertical gutter_right " + this.props.post.vertical}>

        <div className="card_inner_wrapper">
          <div className="top">
            <span className={"card_slug " + this.props.post.vertical}>
              <a href={"/"+this.props.post.vertical}>{this.props.post.vertical}</a> /
              <a href={"/"+this.props.post.category_slug}>
                {this.props.category}
              </a>
            </span>
          </div>

          <div className="bottom card_info_wrapper">
            <a href={this.props.post.permalink} className="permalink">
              <div className="card_info">
      <h4 className="card_headline" dangerouslySetInnerHTML={{__html: this.props.post.title}} />
              </div>

              <div className="card_media">
                <img className="photo fit_w" src={this.props.post.thumbnail_image_src}
                  srcSet={this.props.post.thumbnail_image_srcset}
                  sizes="300px"
                  alt={this.props.post.thumbnail_image_alt}
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
